export default __webpack_public_path__ + "static/media/j15.166fdf17.jpg";